import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { NAV_ITEMS, CONTACT } from "../../mock";

const DesktopNav = ({ pathname, transparent }) => (
  <nav className="hidden lg:flex items-center gap-8">
    {NAV_ITEMS.map((item) => (
      <Link
        key={item.path}
        to={item.path}
        className={`nav-link text-[0.95rem] ${pathname === item.path ? "active" : ""}`}
        style={transparent ? { color: "#fff" } : {}}
      >
        {item.label}
      </Link>
    ))}
    <a
      href={`tel:${CONTACT.phoneRaw}`}
      className="flex items-center gap-2 border border-[#6f5f62] text-[#6f5f62] px-4 py-2 rounded-sm font-sans-el text-sm tracking-wide hover:bg-[#6f5f62] hover:text-white transition-all duration-300"
      style={transparent ? { borderColor: "#fff", color: "#fff" } : {}}
    >
      <Phone size={15} />
      {CONTACT.phone}
    </a>
  </nav>
);

export default DesktopNav;
